module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD7SURBVEiJ7daxSsNQFMbx75x7klS6l4hYWnyGioMOLn0qN9E3EsTBpUMpDj6BFIKQkN0k9p6e66Auglvi4v2vB77feggAttvXs73fXVnA0swS9BgzeWK+F5Gb+fx4Q0VRLtqmWYcQXJ/Qz4hIs9HoVLquvQ0huPH4APnhBCLSK6SqKMsazVsrunu/ZgRcAhgEAwARQZ5PAAAWsGQzc9+HoUqSz20zS3gw5ZciGMEIRjCCEYzgvwCJSAFAvQ6G+K9tIlImpkcAqKoaqvveMVVFVdUAAMf8QMVLsejUr83+5hHm6cn0Kc3chTi5Y2bfN8TMnplXaZaez2ZHzx+Qm11DLpzIXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-canvas-table/images/checkborder.png
// module id = zHTE
// module chunks = 4